import { Component, Input, OnInit } from '@angular/core';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { PortalMessageService } from '../../service/portal-message.service';
import {  Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { UserMessagesIndicationService } from '../../service/user-messages-indication.service';

@Component({
  selector: 'app-user-portal-messages-indicator',
  templateUrl: './user-portal-messages-indicator.component.html',
  styleUrls: ['./user-portal-messages-indicator.component.scss']
})
export class UserPortalMessagesIndicatorComponent implements OnInit {

  constructor(
      private router: Router,
      private uiNotification: UiNotificationService,
      private messageService: PortalMessageService,
      protected userMessagesIndicationService: UserMessagesIndicationService,
      private customDialogService: CustomDialogService) { 
      }
      userMessagesCount$ : Observable<number>;
      userPriorityMessagesCount$ : Observable<number>;
      isLoading:boolean;
      @Input() messageServicingUrl: string;

  ngOnInit(): void {
    this.userMessagesCount$  = this.userMessagesIndicationService.unreadMessagesCount;
    this.userPriorityMessagesCount$ = this.userMessagesIndicationService.unreadPriorityMessagesCount;
    this.userMessagesIndicationService.refreshData();
  }

  goToMessagesList(){
    this.router.navigate([this.messageServicingUrl]);
  }

}
